// extracted by mini-css-extract-plugin
export default {"floor":"FloorName_floor__dQ84C"};